import { observable } from '@legendapp/state';
import type { FreeGiftsData } from '../../../types/front.graphql';

interface ProductGiftsState {
    [sku: string]: {
        giftsDataList: FreeGiftsData[];
        sortedGiftsDataList: FreeGiftsData[];
        loading: boolean;
        error?: string;
        updatedAt?: string;
    };
}

/**
 * Store for managing product gifts data
 * Key by product SKU to support multiple products
 */
export const productGiftsStore$ = observable<ProductGiftsState>({});

/**
 * Clear gifts data for specific SKU
 */
export const clearProductGiftsData = (sku: string): void => {
    productGiftsStore$[sku]?.delete();
};

/**
 * Clear all gifts data from store
 */
export const clearAllProductGiftsData = (): void => {
    productGiftsStore$.set({});
};

/**
 * Reset gifts data for specific SKU (set to initial empty state)
 */
export const resetProductGiftsData = (sku: string): void => {
    productGiftsStore$[sku].set({
        giftsDataList: [],
        sortedGiftsDataList: [],
        loading: false,
        error: undefined,
        updatedAt: undefined,
    });
};
